// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { connectableObservableDescriptor } from "rxjs/internal/observable/ConnectableObservable";

const { $ } = window
const $body = $(document.body)

export default {
   init() {
     // gsap.registerPlugin(ScrollTrigger)
     if(document.querySelector('label[for="user_login"]')) {
      document.querySelector('label[for="user_login"]').innerText = 'Username';
     }
     if(document.querySelector('input[id="user_login"]')) {
      document.querySelector('input[id="user_login"]').placeholder = 'Username or Email Address';
     }
     if(document.querySelector('input[name="pwd"]')) {
      document.querySelector('input[name="pwd"]').placeholder = 'Password';
     }
     if(document.querySelector('#nav a')) {
      document.querySelector('#nav a').innerText = 'Forgot Your Password?';
     }
  },
  finalize() {
     // JavaScript to be fired on the home page, after the init JS
  },
}
